<template>
<div v-if="product">
  <breadcrumb :items="[{ text: 'Produtos', to: '/produtos' }, { text: product.name, to: '/editar-produto/' + product._id }, { text: 'Variações', to: '/editar-produto/' + product._id + '?tab=1' }, { text: product_variation ? product_variation.name : 'Cadastrar variação', active: true }]" />
  <b-form @submit.prevent="save" v-if="!isLoading">
    <h5 class="info-text" v-if="!product.product_variations || !product.product_variations.length"> A partir daqui vamos criar uma primeira variação deste produto. <br />Após o cadastro podemos criar variações a partir desta.</h5>
    <b-form-group label="Nome da variação deste produto *" description="Ex: Yuka mandioca com gergelim">
      <b-form-input v-model="form.name" v-validate="'required'" name="name" />
      <field-error :msg="veeErrors" field="name" />
    </b-form-group>
    <b-form-group label="Descrição desta variação *">
      <b-form-textarea v-model="form.description" v-validate="'required'" name="description" />
      <field-error :msg="veeErrors" field="description" />
    </b-form-group>
    <pictures-upload :form="form" :error="error" field="images" url="uploads/images" :multiple="true" />
    <br>
    <br>
    <h5> CARACTERÍSTICAS DO PRODUTO </h5>
    <hr>
    <div class="row">
      <div class="col-md-6">
        <b-form-group label="Tempo de duração">
          <form-value-with-unit :form="form" field="duration" />
        </b-form-group>
      </div>
    </div>
    <b-form-group label="Atributos">
      <form-tags :form="form" field="tags" :tags="tags" />
    </b-form-group>
    <br>
    <br>
    <h5> VALORES </h5>
    <hr>
    <div class="row">
      <div class="col-md-6">
        <b-form-group label="Preço / unidade">
          <money v-model="form.producer_price" class="form-control" @input="calcBoxPrice"></money>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="Unidades por caixa/embalagem">
          <form-value-with-unit :form="form" field="box_qtd" type="weight" :input="calcBoxPrice" />
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Preço da caixa/embalagem">
          <money v-model="form.box_price" class="form-control"></money>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Impostos">
          <money v-model="form.taxes" class="form-control"></money>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Preço final">
          <h4>{{form.final_price | moeda}}</h4>
        </b-form-group>
      </div>
    </div>
    <br>
    <br>
    <h5> ENVIO E ESTOCAGEM </h5>
    <hr>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Quantidade mínima para envio">
          <form-value-with-unit :form="form" field="minimum_quantity_for_shipping" type="weight" />
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Peso bruto por unidade">
          <form-value-with-unit :form="form" field="gross_weight" type="weight" />
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Peso liquido por unidade">
          <form-value-with-unit :form="form" field="net_weight" type="weight" />
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="NCM*">
          <b-form-input v-model="form.ncm" v-validate="'required'" name="ncm" />
          <field-error :msg="veeErrors" field="ncm" />
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="Código de barras">
          <b-form-input v-model="form.bar_code" />
        </b-form-group>
      </div>
    </div>
    <br>
    <br>
    <h5> INFORMAÇÕES DO PRODUTO PARA O TRANSPORTE </h5>
    <hr>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Largura">
          <form-value-with-unit :form="form" field="box_width" type="size" />
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Altura">
          <form-value-with-unit :form="form" field="box_height" type="size" />
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Comprimento">
          <form-value-with-unit :form="form" field="box_length" type="size" />
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="Peso bruto">
          <form-value-with-unit :form="form" field="box_gross_weight" type="weight" />
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="Empilhamento máximo">
          <b-form-input v-model="form.box_max_stack" type="number" />
        </b-form-group>
      </div>
    </div>
    <form-submit :errors="error" :sending="isSending" />
  </b-form>
</div>
</template>

<script>
import axios from 'axios'
import FormSubmit from '@/components/FormSubmit'
import FieldError from '@/components/FieldError'
import PicturesUpload from '@/components/PicturesUpload'
import FormTags from '@/components/FormTags';
import FormValueWithUnit from '@/components/FormValueWithUnit';

export default {

  name: 'ProductVariationForm',
  data() {
    return {
      empty_form: {},
      form: {
        product: null,
        name: '',
        description: '',
        images: [],

        manufacturing_date: '',
        duration: {
          value: '',
          unit: 'Meses',
        },
        tags: [],

        producer_price: '',
        box_price: '',
        taxes: '',
        final_price: 0,

        box_qtd: {
          value: '',
          unit: 'unidades',
        },
        minimum_quantity_for_shipping: {
          value: '',
          unit: 'Kg',
        },
        gross_weight: {
          value: '',
          unit: 'Kg',
        },
        net_weight: {
          value: '',
          unit: 'Kg',
        },
        ncm: '',
        bar_code: '',

        box_width: {
          value: '',
          unit: 'cm',
        },
        box_height: {
          value: '',
          unit: 'cm',
        },
        box_length: {
          value: '',
          unit: 'cm',
        },
        box_gross_weight: {
          value: '',
          unit: 'Kg',
        },
        box_max_stack: ''
      },
      product_variation: null,
      product: null,
      tags: [{
          text: 'Sem glúten'
        },
        {
          text: 'Sem lactose'
        },
        {
          text: 'Vegano'
        },
      ],
    }
  },
  created() {

    if (this.isEditing()) {
      this.edit(this.$route.params.id)
    }

    axios.get('products/' + this.$route.query.product, {
      params: {
        populate: 'product_variations'
      }
    }).then(response => {
      this.product = response.data
      this.form.product = this.product._id
      if (!this.form.name) {
        this.form.name = this.product.name
      }
      if (!this.form.description) {
        this.form.description = this.product.description
      }

    }).catch(this.showError);

    axios.get('product_variations', {
      params: {
        select: 'tags'
      }
    }).then(response => {
      response.data.forEach(product_variation => {
        product_variation.tags.forEach(tag => {
          this.tags.push(tag)
        })
      });
      this.tags = this.tags.filter((v, i, a) => a.findIndex(t => (t.text === v.text)) === i)
    }).catch(this.showError);
  },
  methods: {
    edit(id) {
      this.isLoading = true
      axios.get('product_variations/' + id).then(response => {
        this.apiDataToForm(this.form, response.data)
        this.product_variation = response.data
        this.isLoading = false
      }).catch(this.showError);
    },
    save() {
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.isSending = true
          this.error = false
          if (!this.form.images || this.form.images.length == 0) {
            this.form.images = this.product.images
          }
          axios({
            method: (this.isEditing() ? 'PUT' : 'POST'),
            url: (this.isEditing() ? 'product_variations/' + this.product_variation._id : 'product_variations'),
            data: this.form
          }).then(resp => {
            var product_variation = resp.data
            if (product_variation && product_variation._id) {
              this.notify("Os dados foram salvos!")
              window.scrollTo(0, 0);
              this.$router.replace('/editar-produto/' + product_variation.product + '?tab=1')
            }
            this.isSending = false
          }).catch(this.showError)
        }
      })
    },
    calcBoxPrice() {
      if (this.form.producer_price && this.form.box_qtd && this.form.box_qtd.value) {
        this.form.box_price = this.form.producer_price * this.form.box_qtd.value
      }
    },
  },
  watch: {
    'form.box_price': function(newVal) {
      this.form.final_price = newVal + this.form.taxes
    },
    'form.taxes': function(newVal) {
      this.form.final_price = this.form.box_price + newVal
    }
  },
  components: {
    FormSubmit,
    FieldError,
    PicturesUpload,
    FormTags,
    FormValueWithUnit
  }
};
</script>
